export const routes: any = {
  all: '/routes',
  signUp: "/sign-up",
  signIn: "/sign-in",
  booking: "/booking",
  bookingCompleted: '/booking-completed',
  test: {
    auth: "/test/auth",
  },
};

export const routesDescription: any = {
  all: 'Показать все маршруты имеющиеся у сервиса',
  signUp: "Показ формы для регистрации.",
  signIn: "Показ формы для входа.",
  booking: "Показ формы бронирования.",
  bookingCompleted: 'Показ формы завершения бронирования.',
  test: {
    auth: "Тестирование внешнего вида, если пользователь авторизован.",
  },
};
